import React, { useEffect, useState, Suspense, lazy } from "react";
import { useMediaQuery } from "react-responsive";
const VideoPlayer = lazy(() => import("./VideoPlayer"));

const VideoHero = ({ videoWebm, videoMp4, posterUrl }) => {
	const prefersReducedMotion = useMediaQuery({
		query: "(prefers-reduced-motion: reduce)",
	});
	const [isPlaying, setIsPlaying] = useState(!prefersReducedMotion);

	useEffect(() => {
		if (prefersReducedMotion) setIsPlaying(false);
	}, [prefersReducedMotion]);

	const togglePlay = () => {
		return setIsPlaying((prev) => !prev);
	};

	let playerProps = {
		muted: true,
		playing: isPlaying,
		playsInline: true,
		loop: true,
		controls: false,
		style: { objectFit: "cover" },
	};

	return (
		<>
			<Suspense fallback={<img src={posterUrl} alt="Video poster" />}>
				<VideoPlayer
					videoUrls={[videoWebm, videoMp4]}
					posterUrl={posterUrl}
					config={playerProps}
				/>
				
				<button
					className={`video-toggle button-reset ${isPlaying ? "is-playing" : "is-paused"}`}
					onClick={togglePlay}
					aria-label={isPlaying ? "pause hero video" : "play hero video"}
				/> 
			</Suspense>
		</>
	);
};

export default VideoHero;
